export const ACTUAL_PLAN_WEEKLY_SPEND = 'actual_spend_weekly';
export const ACTUAL_PLAN_MONTHLY_SPEND = 'actual_spend_monthly';
export const ACTUAL_PLAN_WEEKLY_HEADERS = 'actual_spend_column_headers_weekly';
export const ACTUAL_PLAN_WEEKLY_SPEND_WITHOUT_LOCAL = 'actual_spend_weekly_local';
export const ACTUAL_PLAN_MONTHLY_SPEND_WITHOUT_LOCAL = 'actual_spend_monthly_local';
export const ACTUAL_PLAN_WEEKLY_HEADERS_WITHOUT_LOCAL = 'actual_spend_column_headers_weekly_local';
export const ACTUAL_PLAN_DOWNLOAD_FILE_WEEKLY = 'actual_spend_weekly.xlsx';
export const ACTUAL_PLAN_DOWNLOAD_FILE_WEEKLY_LOCAL_SPEND = 'actual_spend_weekly_local_spend.xlsx';
export const ACTUAL_PLAN_DOWNLOAD_FILE_MONTHLY = 'actual_spend_monthly.xlsx';
export const ACTUAL_PLAN_DOWNLOAD_FILE_MONTHLY_LOCAL_SPEND =
  'actual_spend_monthly_local_spend.xlsx';
export const DATA_KEY_ACTUAL_SPEND = 'spend';
